import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-horizontalLabel",
  "use": "icon-horizontalLabel-usage",
  "viewBox": "0 0 14 12.004",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 12.004\" id=\"icon-horizontalLabel\">\r\n  <path id=\"icon-horizontalLabel_联合_89\" data-name=\"联合 89\" class=\"cls-1\" d=\"M9587-7000h-8v-12h8v1h6v11h-6v0Zm-7-9v8h7v0h5v-7h-6v-3h-6Zm7,0h5v-1h-5Zm-6,1v-1h4v1Z\" transform=\"translate(-9579 7011.999)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol